module.exports = __webpack_public_path__ + "8ef0bd6c416206f915f1a8aff5b4103e.svg";